(function () {
  var revealItems = document.querySelectorAll('.hvac-reveal');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealItems.forEach(function (item) { observer.observe(item); });
  } else {
    revealItems.forEach(function (item) { item.classList.add('is-visible'); });
  }

  document.querySelectorAll('.hvac-btn').forEach(function (button) {
    button.addEventListener('click', function (event) {
      var ripple = document.createElement('span');
      var rect = button.getBoundingClientRect();
      ripple.className = 'hvac-ripple';
      ripple.style.left = (event.clientX - rect.left) + 'px';
      ripple.style.top = (event.clientY - rect.top) + 'px';
      button.appendChild(ripple);
      window.setTimeout(function () { ripple.remove(); }, 650);
    });
  });

  var mobileAtc = document.querySelector('[data-hvac-mobile-atc]');
  if (mobileAtc) {
    var toggleAtc = function () {
      mobileAtc.classList.toggle('is-visible', window.scrollY > 560);
    };
    toggleAtc();
    window.addEventListener('scroll', toggleAtc, { passive: true });
  }

  var filterToggle = document.querySelector('[data-hvac-filter-toggle]');
  var filterPanel = document.querySelector('[data-hvac-filter-panel]');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      filterPanel.classList.toggle('is-open');
      filterPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  }

  document.querySelectorAll('[data-hvac-grid]').forEach(function (button) {
    button.addEventListener('click', function () {
      var grid = document.querySelector('[data-hvac-product-grid]');
      if (!grid) return;
      grid.style.gridTemplateColumns = 'repeat(' + button.getAttribute('data-hvac-grid') + ', minmax(0, 1fr))';
    });
  });

  document.querySelectorAll('[data-hvac-zoom]').forEach(function (button) {
    button.addEventListener('click', function () {
      button.classList.toggle('is-zoomed');
    });
  });
})();
